import { Component } from '@angular/core';

@Component({
  selector: 'app-our-team-and-mission',
  templateUrl: './our-team-and-mission.component.html',
})
export class OurTeamAndMissionComponent {
}
